import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OpenIncidentController } from '@shared/src/controllers/open/openincident.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { HString } from '@shared/src/datatypes/HString';
import { IStandStillDto } from '@shared/src/dtos/incident/IStandStillDto';
import { SharedStandStillAbstractComponent } from '@shared/src/components/route/incident/shared.standstill.component.abstract';
import { Observable } from 'rxjs';

/**
 * El conductor està parat: pot indicar que ha punxat, ampliar el temps parat, reportar-ho o indicar que ja està
 * arreglat (mateixa funcionalitat que l'app, amb els endpoints oberts)
 */
@Component({
    selector: 'shared-external-cmr-agent-standstill',
    templateUrl: './shared.external.cmr.agent.standstill.component.html',
    styleUrls: ['./shared.external.cmr.agent.standstill.component.scss']
})
export class SharedExternalCMRAgentStandStillComponent extends SharedStandStillAbstractComponent {

    constructor(public openIncidentController: OpenIncidentController) {
        super();
        this.refreshStandStill.subscribe(() => this.done.next(true));
    }

    private phaseUUIDValue: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.phaseUUIDValue === value)
            return;
        this.phaseUUIDValue = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.phaseUUIDValue;
    }

    /** Des de la pantalla d'accions: QR de la ruta (en lloc de la fase) */
    private uuidQRValue: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.uuidQRValue === value)
            return;
        this.uuidQRValue = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.uuidQRValue;
    }

    private agentValue: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.agentValue === value)
            return;
        this.agentValue = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.agentValue;
    }

    /** S'emet en fer alguna acció (per tornar enrere es fa servir el botó de la barra) */
    @Output() public done: EventEmitter<boolean> = new EventEmitter();

    private isReady(): boolean {
        return RouteCMRAgentsEnum.isValid(this.agent)
            && (!HString.isNullOrNullString(this.phaseUUID) || !HString.isNullOrNullString(this.uuidQR));
    }

    public loadData(): void {
        if (!this.isReady())
            return;
        this.openIncidentController.getIncidentState(this.phaseUUID, this.uuidQR, this.agent).subscribe(data => {
            this.iHavePricked = data != null && data.iHavePricked;
        });
    }

    protected sendStandStill(standStill: IStandStillDto): Observable<boolean> {
        return this.openIncidentController.reportIStandStill(this.phaseUUID, this.uuidQR, this.agent, this.clearIds(standStill));
    }

    protected sendResolved(standStill: IStandStillDto): Observable<boolean> {
        return this.openIncidentController.resolvedIStandStill(this.phaseUUID, this.uuidQR, this.agent);
    }

    /** La ruta i la fase les determina el backend a partir del UUID */
    private clearIds(standStill: IStandStillDto): IStandStillDto {
        standStill.routeId = null;
        standStill.phaseId = null;
        standStill.shipmentId = null;
        return standStill;
    }

    /** Només serveixen per validar: la ruta i la fase les determina el backend */
    protected getRouteId(): number {
        return 0;
    }

    protected getPhaseId(): number {
        return 0;
    }

    protected getShipmentId(): number {
        return 0;
    }

}
